import React from 'react';
import { DynamicIcon } from '@core/ui';
import { useMemoryGameStore } from '../../../stores/index.js';
import styles from './SavedTicketBanner.module.scss';

const SavedTicketBanner = () => {
    const { goldenFact, redeemTicket: onRedeem, config } = useMemoryGameStore();

    const hasLink = goldenFact?.linkUrl && goldenFact.linkUrl !== '#';
    const destinationUrl = hasLink ? goldenFact.linkUrl : null;
    const ticketIconName = config?.ticket?.iconName;
    const ticketIcon = ticketIconName || 'IconTicket';

    if (hasLink) {
        return (
            <a
                href={destinationUrl}
                target="_blank"
                rel="noopener"
                className={`${styles.bannerButton} anl_memory-game--ticket-link`}
                style={{ textDecoration: 'none' }}
            >
                <span
                    className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                    style={{ width: '36px', height: '36px', backgroundColor: 'rgba(0, 0, 0, 0.12)', flexShrink: 0 }}
                >
                    <DynamicIcon name={ticketIcon} size={20} color="var(--bs-dark, #212529)" strokeWidth={2.5} />
                </span>
                <span className="flex-grow-1 fw-bold small text-dark lh-sm text-start">
                    {goldenFact?.linkButtonText || 'Gewinn-Ticket einlösen'}
                </span>
                <span className="small text-dark fw-bold">→</span>
            </a>
        );
    }

    return (
        <button
            type="button"
            onClick={() => onRedeem()}
            className={`${styles.bannerButton} anl_memory-game--ticket-redeem-btn`}
        >
            <span
                className="d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                style={{ width: '36px', height: '36px', backgroundColor: 'rgba(0, 0, 0, 0.12)', flexShrink: 0 }}
            >
                <DynamicIcon name={ticketIcon} size={20} color="var(--bs-dark, #212529)" strokeWidth={2.5} />
            </span>
            <span className="flex-grow-1 fw-bold small text-dark lh-sm text-start">
                {goldenFact?.linkButtonText || 'Gewinn-Ticket einlösen'}
            </span>
            <span className="small text-dark fw-bold">→</span>
        </button>
    );
};

export default SavedTicketBanner;
